import { useSyncExternalStore } from "react";

const KEY = "cr_wishlist";
const listeners = new Set();
let items = (() => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } })();

const emit = () => { localStorage.setItem(KEY, JSON.stringify(items)); listeners.forEach((l) => l()); };
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
const getSnapshot = () => items;

// item: { id, type: 'place' | 'tour', name, slug, image, meta }
export const wishlist = {
  toggle(item) {
    items = items.some((x) => x.id === item.id) ? items.filter((x) => x.id !== item.id) : [...items, item];
    emit();
  },
  remove(id) { items = items.filter((x) => x.id !== id); emit(); },
  clear() { items = []; emit(); },
  replace(list) { items = list; emit(); },
  items: () => items,
  subscribe,
};

export function useWishlist() {
  const list = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return { list, has: (id) => list.some((x) => x.id === id), toggle: wishlist.toggle, remove: wishlist.remove, clear: wishlist.clear };
}
